import classNames from 'classnames';
import React, { useCallback, useState, useEffect, useMemo } from "react";
import PostShare from "@/components/PostShare/PostShare";
import Button from "@/components/Button/Button";
import IconLink from "@/lib/assets/images/link.svg";
// import IconChecked from '@/lib/assets/images/check-b.svg';
import { Check, MessageSquare } from 'lucide-react';
import { useCopyToClipboard } from "@uidotdev/usehooks";
import Separator from "@/components/Separator/Separator";
import { twMerge } from 'tailwind-merge';
import { createClient } from '@/lib/supabase/component';
import { useCommentsStore } from '@/lib/stores/post';
import BookmarkButton from '@/components/BookmarkButton/BookmarkButton';

export default function PostActions({ className, reverse = false, storyId }) {
  const [copiedText, copyToClipboard] = useCopyToClipboard();
  const [hasCopiedText, setHasCopiedText] = useState(false);

  const supabase = createClient();
  const {
    getTotalCount,
  } = useCommentsStore();

  const totalCommentsCount = getTotalCount(storyId);
  const shortenCommentsCount = totalCommentsCount > 99 ? '99+' : totalCommentsCount;

  let timeout;

  useEffect(() => {
    // Get the total comments count for this story
    getTotalCount(supabase, storyId);
  }, [storyId]);

  const handleCopy = () => {
    if (typeof window === 'undefined') return;
    
    timeout = setTimeout(() => {
      clearTimeout(timeout);
      setHasCopiedText(false);
    }, 2000);

    setHasCopiedText(true);
    return copyToClipboard(window.location.href);
  };


  const ExtraButtons = useMemo(() => (
    <>
      <BookmarkButton storyId={storyId} variant="icon" className="shrink-0" />

      <Separator />

      <Button
        variant={'icon'}
        className={`relative shrink-0`}
        onClick={() => {
          const commentsSection = document.getElementById(`comments-section-${storyId}`);
          if (commentsSection) {
            commentsSection.scrollIntoView({ behavior: 'smooth' });
          }
        }}
        aria-label="View comments"
        title="View comments"
      >
        <MessageSquare strokeWidth={1.75} className={`text-navy dark:text-silver !size-8 !mr-0`} />

        <span className={`text-black dark:text-white absolute top-[3px] text-sm left-1/2 -translate-x-1/2`}>{shortenCommentsCount}</span>
      </Button>
    </>
  ), [totalCommentsCount]);

  return (
    <div
      className={twMerge(classNames(
        'max-md:py-4 max-md:mom-border max-md:border-y-2 flex items-center',
        className
      ))}>
      {reverse ? <>{ExtraButtons}<Separator /></> : null}

      <span className={`relative inline-block`}><PostShare variant={'fill'} /></span>

      <Button
        onClick={handleCopy}
        className={`ml-3 lg:min-w-[147px] lg:px-4 whitespace-nowrap`}
        aria-label={'Copy link'}
      >
        {(hasCopiedText && Boolean(copiedText)) ? (
          <><Check />Link Copied</>
        ) : (
          <><IconLink className={`mr-2`} />Copy <span className={`hidden lg:inline-block`}>Link</span></>
        )}
      </Button>

      {!reverse ? <><Separator />{ExtraButtons}</> : null}
    </div>
  );
}

PostActions.propTypes = {};
